export const screenSizes = {
  xs: 430,
  s: 640,
  m: 768,
  l: 1024,
  xl: 1280,
  xxl: 1536,
} as const

export const breakpoints = {
  xs: `(width <= ${screenSizes.xs}px)`,
  s: `(width <= ${screenSizes.s}px)`,
  m: `(width <= ${screenSizes.m}px)`,
  l: `(width <= ${screenSizes.l}px)`,
  xl: `(width <= ${screenSizes.xl}px)`,
  xxl: `(width <= ${screenSizes.xxl}px)`,
} as const

export type Breakpoint = keyof typeof breakpoints
